// extracted by mini-css-extract-plugin
export default {"section":"Section_section__dpUrR","active":"Section_active__GRisW","section__content":"Section_section__content__CfsIb"};